// Module
var code = "<template> <div> <ess-text value.bind=\"answerText\" labelledby-id.bind=\"labelId\" maxlength.bind=\"1000\" readonly.bind=\"readonly\" value-changed.delegate=\"handleValueChanged()\"></ess-text> </div> </template> ";
// Exports
module.exports = code;